/* Warenkorb-Gesamt: Zepto (pplr_common.js) sucht im Warenkorb Preisfelder über ihren Text und schreibt eine eigene Summe hinein
   (Attribut pplr_set_price). Bewacht werden „Gesamt“ und „Zwischensumme“, jeweils mit data-sm-gesamt. Mit Zusatzzeilen und Rabatt stimmt sie nicht, z. B. 156,85 € statt 147,45 €; die Kasse rechnet richtig.
   Die richtige Summe rendert Liquid in data-sm-gesamt (snippets/sm-cart-summary.liquid, sections/main-cart-footer.liquid).
   Dieses Skript stellt sie wieder her, sobald jemand das Feld ändert. Es beobachtet nur Drawer und Warenkorbseite.
   Die Kassen-Leiste am Handy wird nicht neu gerendert; dort zieht assets/sm-rewards.js data-sm-gesamt bei jeder Änderung nach. */
(function () {
  if (window.SMGesamt || !window.MutationObserver) return;
  window.SMGesamt = 1;
  var SEL = '[data-sm-gesamt]';
  function norm(t) { return String(t || '').replace(/\s+/g, ' ').trim(); }
  function pruefe(el) {
    var soll = el.getAttribute('data-sm-gesamt');
    if (soll == null) return;
    if (norm(el.textContent) === norm(soll)) return;
    // Hat Zepto seinen Preis in ein eigenes span gelegt (pplr_set_price, pplr_s_price), bleibt dieses span samt Attribut stehen und
    // bekommt nur den richtigen Text: ohne seine Markierung fragt Zepto den Warenkorb immer wieder ab
    var z = el.querySelector('[pplr_set_price],[pplr_s_price]');
    if (z) {
      while (el.firstChild) el.removeChild(el.firstChild);
      z.textContent = soll;
      el.appendChild(z);
    } else {
      el.textContent = soll;
    }
  }
  function bewache(el) {
    if (el._smGesamt) return;
    el._smGesamt = new MutationObserver(function () { pruefe(el); });
    el._smGesamt.observe(el, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['pplr_set_price'] });
    pruefe(el);
  }
  function alle(root) {
    if (root.matches && root.matches(SEL)) bewache(root);
    var l = root.querySelectorAll ? root.querySelectorAll(SEL) : [];
    for (var i = 0; i < l.length; i++) bewache(l[i]);
  }
  function start() {
    alle(document);
    // Neue Felder nach einem Neuaufbau der Abschnitte (Entfernen, Hinzufügen, Drawer neu laden)
    var orte = ['cart-drawer', '#main-cart-items', '#main-cart-footer', '#MainContent'];
    for (var i = 0; i < orte.length; i++) {
      var o = document.querySelector(orte[i]);
      if (!o) continue;
      new MutationObserver(function (ms) {
        for (var a = 0; a < ms.length; a++) for (var b = 0; b < ms[a].addedNodes.length; b++) {
          var n = ms[a].addedNodes[b];
          if (n.nodeType === 1) alle(n);
        }
      }).observe(o, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
